import React from 'react';
import { OptionCycler } from '../components/OptionCycler';
import { EYES, EYE_STYLES, MOUTHS, MARKINGS } from '../CharacterCustomizer.constants';
import { TabProps } from './types';

export const FaceTab: React.FC<TabProps> = ({ appearance, setAppearance }) => {
  return (
    <div className="cc-section cc-field-grid">
      <div className="cc-input-group">
        <label className="cc-label">Eyes</label>
        <OptionCycler
          label="eyes"
          value={appearance.eyes}
          options={EYES}
          onChange={v => setAppearance((p: any) => ({ ...p, eyes: v as any }))}
        />
      </div>
      <div className="cc-input-group">
        <label className="cc-label">Eye Style</label>
        <OptionCycler
          label="eye style"
          value={appearance.eyeStyle?.style || 'matched'}
          options={EYE_STYLES}
          onChange={v => setAppearance((p: any) => ({ ...p, eyeStyle: { ...p.eyeStyle, style: v as any } }))}
        />
      </div>
      <div className="cc-input-group">
        <label className="cc-label">Mouth</label>
        <OptionCycler
          label="mouth"
          value={appearance.mouth}
          options={MOUTHS}
          onChange={v => setAppearance((p: any) => ({ ...p, mouth: v as any }))}
        />
      </div>
      <div className="cc-input-group">
        <label className="cc-label">Markings</label>
        <OptionCycler
          label="markings"
          value={appearance.faceMarking || 'none'}
          options={MARKINGS}
          onChange={v => setAppearance((p: any) => ({ ...p, faceMarking: v as any }))}
        />
      </div>
      <div className="cc-input-group cc-input-group--toggle">
        <label className="cc-toggle">
          <input
            type="checkbox"
            checked={appearance.blush}
            onChange={e => setAppearance((p: any) => ({ ...p, blush: e.target.checked }))}
          />
          <span>
            <strong>Rosy cheeks</strong>
            <small>Add a warm blush</small>
          </span>
        </label>
      </div>
    </div>
  );
};
